import { lazy } from "react";

const Support = [
  {
    path: "/admin/support_assistance/:ep_type",
    acl: "view-support_test_type",
    public: true,
    component: lazy(() => import("@src/views/BackOffice/support_assistance")),
  },
  {
    path: "/admin/reclamations/listReclamations",
    acl: "view-tickets",
    component: lazy(() =>
      import("@src/views/BackOffice/tickets/ticket/TableTickets")
    ),
  },
  {
    path: "/admin/ideas/listIdeas",
    acl: "view-ideas",
    component: lazy(() =>
      import("@src/views/BackOffice/tickets/ideas/TableIdeas")
    ),
  },

  {
    path: "/admin/reclamations/:id",
    acl: "view-ticket-id",
    component: lazy(() =>
      import("@src/views/BackOffice/tickets/ticket/TicketById")
    ),
  },

  {
    path: "/admin/idea/:id",
    acl: "view-idea-id",
    component: lazy(() =>
      import("@src/views/BackOffice/tickets/ideas/IdeasById")
    ),
  },
];

export default Support;
